import type { Icon } from "@tabler/icons-react";
import type { ReactNode, PropsWithChildren } from "react";
import { alertBackgroundColorMap, alertTextColorMap, type AlertStatus } from "./alertColours";
import { classNames } from "src/core/utilities/classNames";

interface Props {
    color?: AlertStatus;
    className?: string;

    heading?: ReactNode;
    icon?: Icon;

    actions?: ReactNode;
}

export const LbcAlert = ({ color, heading, children, icon: IconEl, className, actions }: PropsWithChildren<Props>) => (
    <div
        role="alert"
        className={classNames(
            "p-4 rounded-box my-2 w-full @container",
            alertBackgroundColorMap[color ?? "default"],
            alertTextColorMap[color ?? "default"],
            className
        )}
    >
        <div className="flex flex-col @sm:flex-row gap-4">
            <div className="flex gap-4">
                {IconEl && <IconEl className="w-4 h-4 @sm:mt-1" />}

                <div className="space-y-1 grow">
                    {heading && <p className="font-bold">{heading}</p>}

                    <div>{children}</div>
                </div>
            </div>

            {actions && <div className="ml-auto flex gap-2 items-center">{actions}</div>}
        </div>
    </div>
);
